import { pedirModelo } from "./api.js";
import { Depuracion } from "./depuracion.js";
import { descargarModelo } from "./descarga.js";
import { leerEnlace } from "./enlace.js";
import { comoFallo } from "./errores.js";
import { Ui } from "./ui.js";
import { Visor, type EtapaCarga } from "./visor.js";

const ETAPAS: Record<EtapaCarga, string> = {
  decompressing: "Descomprimiendo el modelo",
  parsing: "Leyendo la geometria",
  generating: "Preparando la escena",
  done: "Listo",
};

const contenedor = document.getElementById("escena");
const raizUi = document.getElementById("ui");
if (contenedor === null || raizUi === null) {
  throw new Error("faltan los nodos #escena y #ui en index.html");
}

const ui = new Ui(raizUi);
const depuracion = new URL(window.location.href).searchParams.get("debug") === "1"
  ? new Depuracion(raizUi)
  : undefined;

const aborto = new AbortController();
let visor: Visor | null = null;

async function arrancar(): Promise<void> {
  ui.mostrarCargando("Abriendo el modelo", "Validando el enlace");

  const enlace = leerEnlace(new URL(window.location.href));
  const firmado = await pedirModelo(enlace);

  ui.fijarAvance(0, "Descargando 0.0 MB");
  const bytes = await descargarModelo(
    firmado.url,
    (avance) => ui.actualizarAvance(avance),
    aborto.signal,
  );

  visor = new Visor({ contenedor: contenedor as HTMLElement, depuracion });

  await visor.cargar(bytes, enlace.id, (etapa, fraccion) => {
    ui.fijarAvance(fraccion, ETAPAS[etapa]);
  });

  ui.ocultarCapa();
  ui.montarContexto(firmado.proyecto, firmado.publicadoEn);
  ui.montarToolbar({
    encuadrar: () => visor?.encuadrar(),
    alternarGrid: (activa) => visor?.alternarRejilla(activa),
    alternarSeccion: (activa) => visor?.alternarSeccion(activa),
    elegirEje: (eje) => visor?.fijarEjeSeccion(eje),
  });

  window.addEventListener("keydown", (evento) => {
    if (evento.key !== "f" && evento.key !== "F") return;
    // No robarle la tecla a un campo de texto ni a un atajo del navegador.
    if (evento.metaKey || evento.ctrlKey || evento.altKey) return;
    const activo = document.activeElement;
    if (activo instanceof HTMLInputElement || activo instanceof HTMLTextAreaElement) return;
    evento.preventDefault();
    visor?.encuadrar();
  });
}

// La limpieza va en pagehide y no en beforeunload: beforeunload no dispara en el
// back/forward cache de Safari ni en moviles, y ahi el worker quedaria vivo.
window.addEventListener("pagehide", () => {
  aborto.abort();
  void visor?.dispose();
  depuracion?.dispose();
});

arrancar().catch((causa: unknown) => {
  const fallo = comoFallo(causa);
  // Cualquier ruta de fallo termina en una pantalla explicita, nunca en blanco.
  ui.mostrarError(fallo);
  ui.quitarToolbar();
  ui.quitarContexto();
  console.error(fallo.motivo, causa);
  void visor?.dispose();
});
